export default __webpack_public_path__ + "static/media/cloud-star-bg-sm.537d6205.svg";